export default __webpack_public_path__ + "static/media/alert_bell.8a37b0ba.svg";